<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSearch='false' @load="load" @reset="reset"
                 title="Quản lý thông tin vi phạm" titleIcon="fa fa-tag">
            <template slot="filter">
                <environment-client-select class="mr-2" :model="filterFormModel" attribute="client_id" :errors="formErrors" :label="false" @change="search"/>
            </template>
            <template #cell(client)="{item}">
                <span v-if="item.client_id && params.client[item.client_id]" class="h-word-break">{{params.client[item.client_id].name}}</span>
                <div v-if='params.client[item.client_id].ward_id' >
                    <span class="small text-gray-999">Địa chỉ:</span><span v-if='params.wards[params.client[item.client_id].ward_id]'>{{ params.client[item.client_id].address }}, {{params.wards[params.client[item.client_id].ward_id].name}}</span>
                </div>
            </template>
            <template #cell(content_break)="{item}">
                <span>{{ item.content_break }}</span>
            </template>
            <template #cell(sanctions)="{item}">
                <span>{{ item.sanctions }}</span>
            </template>
            <template #cell(info)="{item}">
                <div v-if="item.minute_time"><span class="small text-gray-999">Ngày lập BBXP: </span>{{item.minute_time * 1000 |  moment('DD/MM/YYYY')}}</div>
                <div v-if="item.start_time"><span class="small text-gray-999">Ngày quyết định XP: </span>{{item.start_time * 1000 |  moment('DD/MM/YYYY')}}</div>
                <div v-if="item.number_break"><span class="small text-gray-999">Số QĐXP: </span>{{ item.number_break }}</div>
            </template>
            <template slot="action">
                <export :filter="filterFormModel" :params='params' :totalCount="itemCount" class="mr-2"/>
                <g-button :loading="saveLoading" v-if="permissions('place-green_create')"  size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(action)="{item}">
                <g-button v-if="permissions('place-green_update')"  :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('place-green_del')"  :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <environment-client-select label="Đơn vị" :model="formModel" attribute="client_id" :errors="formErrors" :required='true'/>
            <form-textarea label="Nội dung vi phạm" :required='true' :model="formModel" attribute="content_break" :errors="formErrors"/>
            <form-textarea label="Hình thức xử phạt" :required='true' :model="formModel" attribute="sanctions" :errors="formErrors" />
            <form-textarea label="Khắc phục" :required='false' :model="formModel" attribute="overcome" :errors="formErrors" />
            <form-input label="Số quyết định xử phạt" :required='true' :model="formModel" attribute="number_break" :errors="formErrors" />
            <div class="row">
                <div class="col-md-6">
                    <form-date-time label="Ngày lập biên bản" :required='true' :model="formModel" attribute="minute_time" format="DD/MM/YYYY" placeholder="DD/MM/YYYY" :errors="formErrors"/>
                </div>
                <div class="col-md-6">
                    <form-date-time label="Ngày quyết định xử phạt" :required='true' :model="formModel" attribute="start_time" format="DD/MM/YYYY" placeholder="DD/MM/YYYY" :errors="formErrors"/>
                </div>
            </div>
            <!-- <form-input label="Cơ quan cấp phép" :required='true' :model="formModel" attribute="number_break" :errors="formErrors" /> -->
            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    import EnvironmentClientSelect from '../../components/EnvironmentClientSelect.vue';
    import Export from './BreakExport';

    export default {
        components: {EnvironmentClientSelect, Export},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadEnvironmentBreak",
                service: '/environment-break',
                fields: [
                    {key: 'client', label: "Đơn vị", class: 'text-left'},
                    {key: 'content_break', label: "Nội dung vi phạm", class: 'text-left'},
                    {key: 'sanctions', label: "Hình thức xử phạt", class: 'text-left'},
                    {key: 'info', label: "Thông tin khác", class: 'text-left'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    // keyword: '',
                },
            }
        },
        watch: {
            "formModel.name": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.slug": {
                handler(val) {
                    if (val) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            }
        },
        methods: {
            search(val) {
                this.filterFormModel.type = val;
                this.load();
            },
            reset() {
                this.filterFormModel.keyword = '';
                this.$router.go(this.$router.currentRoute)
            },
            beforeUpdate(data) {
                data.start_time = data.start_time ? data.start_time * 1000 : null;
                data.minute_time = data.minute_time ? data.minute_time * 1000 : null;
            },
        },
        mounted() {
        }
    }
</script>